/**
 * Bridge nativo per l'app Visite (Android WebView / iOS WKWebView).
 * Stesso schema di Drive (window.VisiteApp + user agent "AffidyaVisite(Android|IOS)/").
 */
export const VISITE_UA_RE = /AffidyaVisite(Android|IOS)\//;

export function isNativeVisiteApp(ua = typeof navigator !== "undefined" ? navigator.userAgent : "") {
  return VISITE_UA_RE.test(ua || "");
}

export function nativeVisitePlatform(ua = typeof navigator !== "undefined" ? navigator.userAgent : "") {
  const m = (ua || "").match(VISITE_UA_RE);
  return m ? (m[1] === "IOS" ? "ios" : "android") : null;
}

export function getVisiteBridge() {
  if (typeof window === "undefined") return null;
  const b = window.VisiteApp;
  return b && typeof b === "object" ? b : null;
}

export function hasBridgeMethod(name) {
  const b = getVisiteBridge();
  return !!b && typeof b[name] === "function";
}

export function isLikelyWebView(ua = typeof navigator !== "undefined" ? navigator.userAgent : "") {
  if (isNativeVisiteApp(ua)) return true;
  if (/; wv\)/.test(ua)) return true;
  return /(iPhone|iPad|iPod).*AppleWebKit(?!.*Safari)/.test(ua);
}

export function isStandaloneDisplay() {
  if (typeof window === "undefined") return false;
  const mq = window.matchMedia && window.matchMedia("(display-mode: standalone)").matches;
  return !!mq || window.navigator?.standalone === true;
}

export function openExternal(url) {
  if (!url) return "none";
  const b = getVisiteBridge();
  if (b && typeof b.openExternal === "function") {
    b.openExternal(String(url));
    return "bridge";
  }
  if (/^(tel|mailto|sms|geo):/i.test(url) || isLikelyWebView() || isStandaloneDisplay()) {
    window.location.assign(url);
    return "location";
  }
  const a = document.createElement("a");
  a.href = url;
  a.target = "_blank";
  a.rel = "noopener noreferrer";
  document.body.appendChild(a);
  a.click();
  a.remove();
  return "anchor";
}

export function haptic(kind = "light") {
  const b = getVisiteBridge();
  if (b && typeof b.haptic === "function") {
    b.haptic(kind);
    return;
  }
  try {
    if (typeof navigator !== "undefined" && typeof navigator.vibrate === "function") navigator.vibrate(kind === "success" ? [10, 40, 10] : 10);
  } catch {
    /* ignore */
  }
}
